import { render, staticRenderFns } from "./ActivitiesForm.vue?vue&type=template&id=6d24e742&scoped=true&"
import script from "./ActivitiesForm.vue?vue&type=script&lang=js&"
export * from "./ActivitiesForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesForm.vue?vue&type=style&index=0&id=6d24e742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24e742",
  null
  
)

export default component.exports